<!--
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-03-30 15:23:09
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-07-02 15:30:20
 -->
<template>
  <div class="ape-container" :style="{backgroundImage: 'url('+this.mxDomain.backgroundImg+')'}">
	<div class="logo-top" >
	<img v-if="this.is_zhengye" class="logo-img" src="https://xl-online.oss-cn-hangzhou.aliyuncs.com/B_newmanage/zye/zye_lt_logo.png" alt="" />
	</div>
	<div class="link-box" @click="goPage" v-if="is_show_link"> </div>
    <div class="header" v-if="this.mxDomain.logo_top">
      <div class="header-img">
        <a href="/">
          <img :src="this.mxDomain.logo_top"/>
        </a>
      </div>
    </div>
    <div class="ape-content">
      <div  class="ape-left" v-if="this.$config.domain.domain === 'khl-yfx.51xinlong.com'">
        <div class="left-one">数字化(灵活)用工综合服务平台</div>
        <div class="left-two">
          致力于提供合法、合规、安全、稳定的用工管理和结算服务
        </div>
        <div class="left-two">打造行业标杆，成为行业典范</div>
      </div>
	<div
		v-if="this.is_zhengye"
	class="ape-left"
	>
	<div class="left-one">灵活用工一站式服务平台</div>
	<div class="left-two">构建灵活用工系统，通过高效连接企业、自由职业者、支付机构与税务部门，</div>
	<div class="left-two">
	实现社会资源配置效率提升与企业用工成本优化，保障全流程合规管控。
	</div>
	</div>
	<div
		v-else
	class="ape-left"
	>
	<div class="left-one">{{this.$config.domain.ename==='aqzhexing'?"望江织女劳务用工平台":'灵活用工一站式服务平台'}}</div>
	<div class="left-two">提高社会资源配置效率，降低企业用工成本</div>
	<div class="left-two">
	实现企业、自由职业者、支付机构、税务部门的互联互通
	</div>
	</div>
      <div class="ape-right">
        <div class="ape-top">
          <div class="ape-header">
            <a href="/">
              <img alt="" class="ape-logo" :src="this.mxDomain.logo" />
            </a>
          </div>
          <div class="ape-desc"></div>
        </div>
        <router-view />
      </div>
    </div>
    <Footer :tag="tag"/>
  </div>
</template>
<script>
import Footer from './Footer'
import {ZYE_NAME} from '@/config/const_name.js'
export default {
  components: {
    Footer,
  },
  data(){
    return {
      tag: true,
	is_show_link:false,
	is_zhengye:false,
    }
  },
  methods:{
	goPage(){
			//测试 https://togtestb2b.51xinlong.com/  正式 https://b2b.51xinlong.com
			let url=''
			let status='dev' // 正式 pro  测试 dev
			if(status==='dev'){
				url='https://togtestb2b.51xinlong.com'
			}else{
				url='https://www.51xinlong.com/'
			}
			
			window.open(url)
		}  
  },
  created() {
	//this.is_show_link=['trade.51xinlong.com'].includes(window.location.host)
    console.log(window.location.host,location.hostname)
	//正晔（杭州）数字科技有限公司
	if(this.$config.domain.ename===ZYE_NAME){
		this.is_zhengye=true
	}

  },
}
</script>
<style lang="scss" scoped>
	.link-box
		{
			position: fixed;
			top: 0;
			left: 0;
			z-index: 3;
			height: 60px;
			background-image: url(https://xl-online.oss-cn-hangzhou.aliyuncs.com/images/desc_link.png);
			background-repeat: no-repeat;
			background-size: 100%;
			width: 100%;
			cursor: pointer;
		}
</style>
<style lang="stylus">
  $screen-md-min = 768px
  $heading-color = rgba(0, 0, 0, 0.85)
  $font-size-base = 14px
  $text-color-secondary = rgba(0, 0, 0, 0.45)
	
	
  .ape-container
    display flex
    flex-direction column
    height 100vh
    overflow hidden
    background #f0f2f5
    background-size cover
  .header
    width: 100%
    height: 60px
    position: absolute
    top: 0
    background: #fff
    display: flex
    flex-direction: row
    align-items: center
  .header-img
    margin-left: 10%
  .ape-right/deep/.el-form
    margin-bottom: 40px
  .ape-content
    // flex 1
    // display flex
    display: -webkit-box
    flex-direction row
    .ape-left
      flex: 1
      color: #fff
      margin-top: 2%
      margin-left: 5%
    .left-one
      font-size: 45px
      margin-left: 10%
      padding: 20px 0
      font-weight: bolder
      letter-spacing: 5px
    .left-two
      margin-left: 10%
      font-size: 20px
      padding: 5px 0
      letter-spacing: 1px
    .ape-right
      width 459px
      background-color #ffffff
      margin-right 10%
  @media (min-width $screen-md-min)
    .ape-container
      background-size cover
    .ape-content
      padding 10% 0 20% 0
  @-moz-document url-prefix()
    .ape-content
      padding 10% 0 0 0
  .ape-top
    text-align center
    margin-top 50px
  .ape-header
    a
      text-decoration none
  .ape-logo
    height 80px
    vertical-align top
    margin-right 4px
  .ape-title
    font-size 33px
    color $heading-color
    font-family "Myriad Pro", "Helvetica Neue", Arial, Helvetica, sans-serif
    font-weight 600
    position relative
    top -2px
  .ape-desc
    font-size $font-size-base
    color $text-color-secondary
    margin-top 8px
    margin-bottom 32px
.logo-top{
	position: fixed;
	top: 27px;
	left: 30px;
}
.logo-img{
	width: 100px;
	height: 36px;
}

</style>


